import { render, staticRenderFns } from "./CardForm.vue?vue&type=template&id=59b01e19"
import script from "./CardForm.vue?vue&type=script&lang=js"
export * from "./CardForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports